import { render } from "./CheckoutShippingTotals.vue?vue&type=template&id=69214082"
import script from "./CheckoutShippingTotals.vue?vue&type=script&lang=js"
export * from "./CheckoutShippingTotals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__